export default "__VITE_ASSET__N_kg5g$N__"